module.exports = __webpack_public_path__ + "static/play-store_badge--black-46357c6a6a02d715837dac2c86a4a951.svg";